module.exports = __webpack_public_path__ + "img/syukyaku-EC-mo-ira001.c726df8f.png";